import { propClassName } from '@/styles/SavedArticles';
import { cn } from 'lib/utils/cn';
import type { ClassNameProp, Component, ComponentProps } from 'types/component';

export interface SavedArticlesIconProps extends ComponentProps<'div'> {
  variant?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
}

export const SavedArticlesIconComponent: Component<SavedArticlesIconProps> = ({
  className,
  variant,
  colors,
  size,
  children,
  ...props
}) => {
  const variantClassName = propClassName('icon_variant', variant, 'default');
  const colorsClassName = propClassName('icon_colors', colors, 'default');
  const sizeClassName = propClassName('icon_size', size, 'default');
  const componentClassName = cn(variantClassName, colorsClassName, sizeClassName, className);

  return (
    <div className={componentClassName} {...props}>
      {children}
    </div>
  );
};
